module.exports = __webpack_public_path__ + "img/profile.ec4537e9.svg";